export default __webpack_public_path__ + "static/media/all-product-modal-right.0fa593c3.svg";